export class FnBaseFilter {
    displayName: string;
    primaryKey: string;
    constructor(displayName: string, primaryKey: string) {
        this.displayName = displayName;
        this.primaryKey = primaryKey;
    }
}
export class FNBaseEventFilter { }
/**
 * Data Model For Filter Options
 */
export class FnFilterOption extends FnBaseFilter {
    isDefaultOption: boolean;
    constructor(
        displayName: string,
        primaryKey: string,
        isDefaultOption?: boolean
    ) {
        super(displayName, primaryKey);
        this.isDefaultOption = isDefaultOption;
    }
}

/**
 * Data Model For Event Filter
 */
export class FnEventFilter extends FnBaseFilter {
    fnFilterOptionArray: Array<FnFilterOption>;
    selectedKey: string;
    constructor(
        displayName: string,
        primaryKey: string,
        selectedKey: string,
        fnFilterOptionArray: Array<FnFilterOption>
    ) {
        super(displayName, primaryKey);
        this.selectedKey = selectedKey;
        this.fnFilterOptionArray = fnFilterOptionArray;
    }
    activeOption?: FnFilterOption;
    buildFnFilterArray(
        buildArray: Array<any>,
        labelKey: string,
        bindKey: string
    ) {
        if (this.fnFilterOptionArray === undefined) {
            this.fnFilterOptionArray = [];
        }
        for (let i = 0; i < buildArray.length; i++) {
            this.fnFilterOptionArray.push(
                new FnFilterOption(
                    buildArray[i][labelKey],
                    buildArray[i][bindKey],
                    false
                )
            );
        }
    }
}
export class FnCheckboxFilterOption extends FnFilterOption {
    isSelected = true;
    constructor(
        displayName: string,
        primaryKey: string,
        isDefaultOption?: boolean,
        isSelected = true
    ) {
        super(displayName, primaryKey, isDefaultOption);
        this.isSelected = isSelected;
    }
}
export class FnCheckboxEventFilter extends FnBaseFilter {
    fnFilterOptionArray: Array<FnCheckboxFilterOption>;
    parentOption: FnCheckboxFilterOption;
    selectedOptionArray: Array<string> = [];
    public noOfOptionSelected: number;
    constructor(
        displayName: string,
        primaryKey: string,
        parentOption: FnCheckboxFilterOption,
        fnFilterOptionArray?: Array<FnCheckboxFilterOption>,
        isInitReset = true
    ) {
        super(displayName, primaryKey);
        this.parentOption = parentOption;
        if (fnFilterOptionArray === undefined) {
            this.fnFilterOptionArray = [];
        } else {
            this.fnFilterOptionArray = fnFilterOptionArray;
            this.reselectAllOptions(isInitReset);
        }
    }


    buildFnFilterArray(
        buildArray: Array<any>,
        labelKey: string,
        bindKey: string,
        isAllSelected = true,
    ) {
        let noOfSelected = 0;
        for (let i = 0; i < buildArray.length; i++) {
            const value = buildArray[i];
            this.fnFilterOptionArray.push(
                new FnCheckboxFilterOption(
                    value[labelKey],
                    value[bindKey] + '_' + this.primaryKey,
                    false,
                    value.isSelected
                )
            );
            if (isAllSelected || value.isSelected) {
                this.selectedOptionArray.push(buildArray[i][bindKey] + '');
                noOfSelected++;
            }
        }
        this.noOfOptionSelected = noOfSelected;
        this.parentOption.isSelected = this.noOfOptionSelected == this.fnFilterOptionArray.length;
    }

    reselectAllOptions(_argo = true) {                   
            this.noOfOptionSelected = 0;
            this.selectedOptionArray = []
            for (let i = 0; i < this.fnFilterOptionArray.length; i++) {                
                if(_argo || this.fnFilterOptionArray[i].isSelected){
                    this.fnFilterOptionArray[i].isSelected = true; 
                }

                   if(this.fnFilterOptionArray[i].isSelected){
                    this.selectedOptionArray.push(
                        this.fnFilterOptionArray[i].primaryKey.replace(
                            '_' + this.primaryKey,
                            ''
                        )
                    );  
                    this.noOfOptionSelected++;   
                   } 
            }
            this.parentOption.isSelected = this.noOfOptionSelected == this.fnFilterOptionArray.length; 
       
    }
}
